import React from 'react';
import styled from '@emotion/styled';

const FallbackContainer = styled.div`
  padding: 2rem;
  text-align: center;
  max-width: 600px;
  margin: 2rem auto;
  background: #f8f9fa;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  color: #2d3748;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
`;

const Message = styled.p`
  color: #4a5568;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const FallbackComponent = () => (
  <FallbackContainer>
    <Title>Something went wrong</Title>
    <Message>
      We are sorry for the inconvenience. Our team has been notified.
    </Message>
  </FallbackContainer>
);

export default FallbackComponent;
